import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { closeDrawer, getURLSegment } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import { checkValidity } from '../../helpers/helpers.js'

// Components
import Step from '../Common/Step';
import RegisterStep from './RegisterStep';

const RegisterForm = observer(class RegisterForm extends React.Component {
  constructor() {
    super();
    this.setStep = this.setStep.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    const { LocationStore, ProctorStore } = this.props.store;

    this.state = {
      step: this.props.step || 1,
      mode: 'add',
      skippable: false,
      proctorSid: null,
      locationSid: null,
      accountData: {}
    }

    // If editing, get the data from store
    if(getURLSegment(this, 2) === 'edit') {
      const proctorSid = getURLSegment(this, 3);

      this.setState({
        proctorSid,
        mode: 'edit',
        skippable: true
      });

      ProctorStore.getProctor(proctorSid, this);
      LocationStore.getSelfManagedAccountLocation(proctorSid, this);
    }
  }

  setStep(e, step) {
    e.preventDefault();

    this.setState({
      step
    });
  }

  nextStep(e) {
    if(e) {
      e.preventDefault();
    }

    const _this = this;

    this.setState({
      step: this.state.step + 1
    });
  }

  prevStep() {
    this.setState({
      step: this.state.step - 1
    });
  }

  handleInput(e, name) {
    let accountData = {...this.state.accountData};

    // Set name to form field
    if(name === 'phoneNumber') {
      accountData[name] = e;
    } else {
      accountData[name] = e.target.value;
    }

    this.setState({
      accountData
    })
  }

  handleToggle(e, name, key) {
    let accountData = {...this.state.accountData};
    let index = accountData[name].indexOf(key);

    if (e.target.checked && index === -1) {
      // If checked, push key in array
      accountData[name].push(key);
    } else if (index !== -1) {
      // If unchecked, remove key from array
      accountData[name].splice(index, 1);
    }

    this.setState({
      accountData
    });
  }

  handleSubmit(e) {
    const { ProctorStore } = this.props.store;
    const cb = (e) => this.nextStep(e);

    if(this.state.mode === 'edit') {
      ProctorStore.updateSelfManagedAccount(ProctorStore.proctorSid, this.state.accountData, cb);
    } else {
      ProctorStore.addSelfManagedAccount(this.state.accountData, cb, this);
    }
  }

  render() {
    const { store, translation } = this.props;
    const { SessionStore } = store;

    if(SessionStore.loadingCalls.indexOf('GetProctorData') < 0) {
      return(
        <div className={`wrap block-form ${this.state.step === 3 ? 'block-form--alt' : 'no'}`}>
          <Step step={this.state.step} setStep={this.setStep} data={translation.steps} skippable={this.state.skippable} />

          <RegisterStep
            step={this.state.step}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            checkValidity={checkValidity}
            handleInput={this.handleInput}
            handleToggle={this.handleToggle}
            handleSubmit={this.handleSubmit}
            closeDrawer={closeDrawer}
            accountData={this.state.accountData}
            proctorSid={this.state.proctorSid}
            locationSid={this.state.locationSid}
            parent={this}
            {...this.props}
          />
        </div>
      );
    }

    return null;
  }
})

export default translate('RegisterForm')(RegisterForm);


// WEBPACK FOOTER //
// ./src/app/components/Register/RegisterForm.js